// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/leadView.css
// module id = 567
// module chunks = 0